import { render, staticRenderFns } from "./AssignGlobalSoundGroupPopup.vue?vue&type=template&id=b013ad7a&scoped=true"
import script from "./AssignGlobalSoundGroupPopup.vue?vue&type=script&lang=ts"
export * from "./AssignGlobalSoundGroupPopup.vue?vue&type=script&lang=ts"
import style0 from "./AssignGlobalSoundGroupPopup.vue?vue&type=style&index=0&id=b013ad7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b013ad7a",
  null
  
)

export default component.exports